import { forwardRef } from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faBold,
  faCode,
  faHeading,
  faItalic,
  faLink,
  faListOl,
  faListUl,
  faStrikethrough,
} from "@fortawesome/pro-solid-svg-icons";
import { twJoin, twMerge } from "tailwind-merge";

import { Icon } from "src/base-components/Icon";

const ToolbarItem: React.FC<{
  icon: IconProp;
  type: string;
  value?: string;
}> = ({ icon, type, value }) => (
  <li>
    <button className={twJoin(type, "rounded")} value={value}>
      <Icon icon={icon} size="xs" />
    </button>
  </li>
);

type Props = {
  faded?: boolean;
  exclude?: (
    | "heading"
    | "bold"
    | "italic"
    | "strikethrough"
    | "link"
    | "listUl"
    | "listOl"
    | "code"
  )[];
};

export const Toolbar = forwardRef<HTMLUListElement, Props>(
  ({ faded, exclude = [] }, ref) => {
    const controlledFaded = faded !== undefined;
    const controlledFadedClass =
      faded === true ? "text-gray-300" : "text-gray-500";

    return (
      <ul
        ref={ref}
        className={twMerge(
          "flex items-center gap-x-1",
          controlledFaded
            ? controlledFadedClass
            : "text-gray-300 group-focus-within:text-gray-500",
        )}
      >
        {!exclude.includes("heading") && (
          <ToolbarItem icon={faHeading} type="ql-header" value="1" />
        )}
        {!exclude.includes("bold") && (
          <ToolbarItem icon={faBold} type="ql-bold" />
        )}
        {!exclude.includes("italic") && (
          <ToolbarItem icon={faItalic} type="ql-italic" />
        )}
        {!exclude.includes("strikethrough") && (
          <ToolbarItem icon={faStrikethrough} type="ql-strike" />
        )}
        {!exclude.includes("link") && (
          <ToolbarItem icon={faLink} type="ql-link" />
        )}
        <li className="text-gray-200">|</li>
        {!exclude.includes("listUl") && (
          <ToolbarItem icon={faListUl} type="ql-list" value="bullet" />
        )}
        {!exclude.includes("listOl") && (
          <ToolbarItem icon={faListOl} type="ql-list" value="ordered" />
        )}
        {!exclude.includes("code") && (
          <ToolbarItem icon={faCode} type="ql-code" />
        )}
      </ul>
    );
  },
);
